import React from 'react';

const partnerLogos = [
  { src: '/partners/Dubai.webp', alt: 'Dubai Tourism Logo', width: 180, height: 120, hint: 'dubai tourism logo' },
  { src: '/partners/Dubai-2.webp', alt: 'Dubai Chamber Logo', width: 180, height: 120, hint: 'dubai chamber logo' },
  { src: '/partners/Iso.webp', alt: 'ISO Certified Logo', width: 120, height: 120, hint: 'iso certified logo' },
  { src: '/partners/Eagle.webp', alt: 'Dubai Immigration Logo', width: 120, height: 120, hint: 'dubai immigration logo' },
  { src: '/partners/Blue-Dubai.webp', alt: 'Government of Dubai Logo', width: 180, height: 120, hint: 'government dubai logo' },
];

export function PartnerLogos() {
  return (
    <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-6 md:gap-x-12 lg:gap-x-16">
      {partnerLogos.map((logo, index) => (
        <div key={index} className="flex justify-center">
          <img
            src={logo.src}
            alt={logo.alt}
            width={logo.width}
            height={logo.height}
            className="object-contain"
            data-ai-hint={logo.hint}
          />
        </div>
      ))}
    </div>
  );
}
